import React from 'react'

import CountUpWrapper from '../CountUpWrapper'
import ImpactVideo    from './ImpactVideo'
import { ImpactIcon } from '../SpriteIcon'

const ImpactWidget = props =>
  <div
    className={`impact-widget flex-fill bg-cover ${props.className || ''}`}
    style={{
      backgroundColor: props.color,
      backgroundImage: props.image && `url("${props.image}")`,
    }}
  >
    {props.video && <ImpactVideo src={props.video} />}

    <div className="impact-widget-inner position-relative h-100 d-flex flex-column justify-content-around">
      <div className="p-3 text-center">
        <div className={`impact-widget-icon mt-4 mb-2 ${props.iconClassName || ''}`}>
          <ImpactIcon icon={props.icon} />
        </div>

        <h2 className={`impact-widget-title font-weight-normal ${props.titleClassName || ''}`}>
          {props.currency_symbol}
          <CountUpWrapper amount={props.amount} />
        </h2>

        <p className={`impact-widget-description font-weight-normal ${props.descClassName || ''}`}>
          {props.description}
          {props.sdg && <span className="font-weight-light"
            style={{ color: 'rgba(255,255,255,0.85)' }}><br />{props.sdg}</span>}
        </p>
      </div>
    </div>

  </div>

export default ImpactWidget
